import { broadcasterTranslations } from './broadcaster';
import { guestTranslations } from './guest';
import { interactionTranslations } from './interaction';
import { rtmpTranslations } from './rtmp';
import { sharedTranslations } from './shared';

export const translations = {
  ...guestTranslations,
  ...broadcasterTranslations,
  ...sharedTranslations,
  ...interactionTranslations,
  ...rtmpTranslations,
};

export { NormalizedGraphicsDescriptorType } from './broadcaster';
